/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridActionsCellItem, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import {
  Autocomplete,
  Stack,
  Typography,
  Card,
  Chip,
  CardContent,
  TextField,
  Grid,
  InputAdornment,
  IconButton
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import DatePicker from 'react-datepicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSkeleton from '../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../utils/NoRowOverlay';
import PaymentAction from '../../store/actions/PaymentAction';
import CopyInput from '../../components/CopyInput';
import ManualTransactionEdit from './manual-edit';

function QuickSearchToolbar() {
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        />
      </Stack>
    </Box>
  );
}

export default function ManualTransaction() {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });

  const [sortInfo, setSortInfo] = useState({
    sortField: '',
    sort: ''
  });
  const navigate = useNavigate();
  const [rowCountState, setRowCountState] = useState(0);
  const [itemId, setItemId] = useState('');
  const [editOpen, setEditOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState('');
  const [data, setData] = useState([]);
  const [paymentGateway, setPaymentGatway] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [searchWord, setSearchWord] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const dispatch = useDispatch();

  const { manualData, isLoading, manualfilterData } = useSelector((state) => state.payment);
  const { payment_type, payment_gateway } = manualfilterData;
  const { paginationData, sortingData, payMethod, payType, keyword, rangeDateData } = useSelector(
    (state) => state.payment.manualQueryParams
  );

  useEffect(() => {
    const rangeDate = {
      dateStart: startDate,
      dateEnd: endDate
    };
    dispatch(
      PaymentAction.updateManualQueryParams(
        paginationModel,
        sortInfo,
        paymentGateway,
        paymentType,
        searchWord,
        rangeDate
      )
    );
    dispatch(
      PaymentAction.getAllManualPayment(
        paginationModel,
        sortInfo,
        paymentGateway,
        paymentType,
        searchWord,
        rangeDate
      )
    );
  }, [
    dispatch,
    paginationModel,
    sortInfo,
    paymentGateway,
    paymentType,
    searchWord,
    startDate,
    endDate
  ]);

  useEffect(() => {
    dispatch(PaymentAction.getManualPaymentFilter());
  }, [dispatch]);

  useEffect(() => {
    if (manualData) {
      if (manualData.data) {
        setData(manualData.data);
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        manualData.total !== undefined ? manualData.total : prevRowCountState
      );
    }
  }, [manualData]);

  useEffect(() => {
    if (paginationData) {
      setPaginationModel(paginationData);
    }
    if (sortingData) {
      setSortInfo(sortingData);
    }
    if (keyword) {
      setSearchWord(keyword);
    }
    if (payType) {
      setPaymentType(payType);
    }
    if (payMethod) {
      setPaymentGatway(payMethod);
    }
    if (rangeDateData && rangeDateData.length > 0) {
      setDateRange(rangeDateData);
    }
  }, [paginationData, keyword, sortingData, payType, payMethod, rangeDateData]);

  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      sortable: false,
      align: 'left',
      flex: 0.3,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'name',
      headerName: 'Client Name',
      // flex: 0.75
      width: 200
    },
    {
      field: 'invoice_number',
      headerName: 'Invoice No',
      flex: 0.75
    },
    {
      field: 'payment_gateway',
      headerName: 'Payment Method',
      flex: 1
    },
    {
      field: '_created_at',
      headerName: 'Paid Date',
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography component="p" variant="body1">
              {params.value}
            </Typography>
          );
        }
        return (
          <Typography component="p" variant="body1">
            -
          </Typography>
        );
      }
    },
    {
      field: 'amount',
      headerName: 'Paid Total',
      flex: 0.75,
      renderCell: (params) => {
        if ((params && params.value) || (params.row && params.row.symbol)) {
          return (
            <Typography component="p" variant="body1">
              {`${params.row.short_name} ${params.value}`}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'transaction_id',
      headerName: 'Transaction ID',
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Typography title={params.value} component="p" variant="body1">
              {params.value}
            </Typography>
          );
        }
        return null;
      }
    },
    {
      field: 'payment_type_name',
      headerName: 'Payment Type',
      flex: 0.75,
      renderCell: (params) => {
        if (params && params.value) {
          return (
            <Chip
              title={params.value}
              label={params.value}
              color={params.value.toLowerCase().replace(/\s+/g, '')}
            />
          );
        }
        return null;
      }
    },
    // {
    //   field: 'status_name',
    //   headerName: 'Transaction Status',
    //   flex: 0.75,
    //   renderCell: (params) => {
    //     if (params && params.value) {
    //       return (
    //         <Chip label={params.value} color={params.value.toLowerCase().replace(/\s+/g, '')} />
    //       );
    //     }
    //     return null;
    //   }
    // },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<i className="icon-view" />}
          className="actionBtn"
          title="View"
          label="View"
          onClick={() => {
            navigate(`/transaction/manual/view/${params.id}`);
          }}
        />,
        params.row && params.row.edit ? (
          <GridActionsCellItem
            icon={<i className="icon-edit" />}
            className="actionBtn"
            title="Edit"
            label="Edit"
            onClick={() => {
              setModalStatus(params?.row?.payment_type_name);
              setItemId(params.id);
              setEditOpen(true);
            }}
          />
        ) : (
          <span />
        )
      ]
    }
  ];
  const handleRangePicker = (date) => {
    if (!date || date.length !== 2 || date[1] === null) {
      return;
    }
    const formatDate = (newdate) => {
      return dateFormat(newdate, 'yyyy-mm-dd');
    };
    setDateRange(date.map(formatDate));
  };
  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    } else {
      dispatch(
        PaymentAction.getAllTransaction(
          paginationModel,
          sortInfo,
          paymentGateway,
          paymentType,
          searchWord
        )
      );
    }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const keywordData = filterModel.quickFilterValues[0];
    setSearchWord(keywordData);
    setPaginationModel({ page: 0, pageSize: 10 });
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <Card className="pageTitleWrap" sx={{ mb: 3 }}>
        <CardContent>
          <Grid container columnSpacing={3}>
            <Grid item md={3} lg={3}>
              <Autocomplete
                className="filter"
                fullWidth
                size="small"
                options={payment_type ?? []}
                onChange={(e, newvalue) => {
                  if (newvalue && newvalue?.id) {
                    setPaymentType(newvalue.id);
                  } else {
                    setPaymentType('');
                  }
                  setPaginationModel({ page: 0, pageSize: 10 });
                }}
                sx={{ mt: 0 }}
                getOptionLabel={(option) => option.status}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.status}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Type"
                    placeholder="Search Type"
                    variant="outlined"
                    margin="none"
                  />
                )}
              />
            </Grid>
            <Grid item md={3} lg={3}>
              <Autocomplete
                className="filter"
                fullWidth
                size="small"
                options={payment_gateway ?? []}
                onChange={(e, newvalue) => {
                  if (newvalue) {
                    setPaymentGatway(newvalue);
                  } else {
                    setPaymentGatway('');
                  }
                  setPaginationModel({ page: 0, pageSize: 10 });
                }}
                sx={{ mt: 0 }}
                getOptionLabel={(option) => option}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Method"
                    placeholder="Search Method"
                    variant="outlined"
                    margin="none"
                  />
                )}
              />
            </Grid>
            <Grid item md={3} lg={3}>
              <Box className="datepicker">
                <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                    handleRangePicker(update);
                    setPaginationModel({ page: 0, pageSize: 10 });
                  }}
                  monthsShown={2}
                  isClearable
                  customInput={
                    <TextField
                      label="Date"
                      fullWidth
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              disabled
                              // color="secondary"
                            >
                              <CalendarMonthIcon sx={{ color: '#fff' }} />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  }
                />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '50vh' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>
      {editOpen === true ? (
        <ManualTransactionEdit
          itemId={itemId}
          openmodal={editOpen}
          modalstatus={modalStatus}
          onCloseModal={() => setEditOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
